import React from "react";

export const Logo: React.FC<{ className?: string }> = ({ className }) => (
  <span
    className={`promptBadge ${className ?? ""}`.trim()}
    aria-hidden="true"
  >
    $_
  </span>
);
